module.exports = __webpack_public_path__ + "img/character-both-normal.a93f984b.svg";